import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import Modal from 'react-modal'
import CacheManager from '../../../cache/CacheManager'
import TestAccountListUI from './TestAccountListUI'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class TestAccountListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      selectedLoanId: null,
      deleteLoanSubmitted: false,
      deleteLoanResult: null,
    }
  }

  render() {
    const accountKeyValueList = this.props.accountList.map((account) => ({
      key: account.accountId,
      value: account.accountName,
    }));
    console.log(this.state.loanId)
    return (
      <TestAccountListUI
        context={this.props.context}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        accountList={this.props.accountList}
        accountKeyValueList={accountKeyValueList}
        accountSubmitted={this.state.accountSubmitted}
        updateMode={this.state.updateMode}
        onUpdateClick={this.onUpdateClick}
        onCancelClick={() => { this.setState({ updateMode: false }) }}
        onRefreshClick={this.props.onRefreshClick}
        selectedAccountId={this.props.selectedAccountId}
        onDeleteClick={this.props.onDeleteClick}
        deleteSubmitted={this.props.deleteSubmitted}
        onRecreateClick={this.props.onRecreateClick}
        recreateSubmitted={this.props.recreateSubmitted}
        // loan
        createLoanMode={this.props.createLoanMode}
        onCreateLoanClick={this.props.onCreateLoanClick}
        onCancelCreateLoan={this.props.onCancelCreateLoan}
        selectedLoanId={this.state.selectedLoanId}
        deleteLoanSubmitted={this.state.deleteLoanSubmitted}
        deleteLoanResult={this.state.deleteLoanResult}
        onDeleteLoanClick={this.onDeleteLoanClick}
        onCloneLoanClick={this.onCloneLoanClick}
        onHideDeleteLoanResult={() => { this.setState({ deleteLoanResult: null }) }}
      //
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onUpdateClick = (event) => {
    let loanId = event.target.getAttribute('data-row-id')
    this.setState({ updateMode: true, selectedLoanId: loanId })
  }

  onDeleteLoanClick = (event) => {
    let deleteLoanSubmitted = this.state.deleteLoanSubmitted
    if (deleteLoanSubmitted)
      return

    let loanId = event.target.getAttribute('data-row-id')

    this.setState({
      successMsg: null,
      errorList: [],
      selectedLoanId: loanId,
      deleteLoanSubmitted: true
    })

    RestApiUtils.delete(this.props.context,
      `/api/su/test/loans/${loanId}`,
      this.onDeleteLoanClickCallback
    )
  }

  onDeleteLoanClickCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      deleteLoanSubmitted: false,
      deleteLoanResult: response.result
    })

    if (response.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.Loans())
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onRefreshClick()
      }, 2000)
    }
  }
}

export default TestAccountListSF
